import { Navigate, useParams } from "react-router-dom";
import { customerAddCodePath, customerDetailPath } from "../routes/customerRoutes";

export function LegacyCustomerDetailRedirect() {
  const { id } = useParams();
  return <Navigate to={customerDetailPath(id)} replace />;
}

export function LegacyCustomerAddCodeRedirect() {
  const { id } = useParams();
  return <Navigate to={customerAddCodePath(id)} replace />;
}
